import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WorkflowModule } from './workflow/workflow.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FileuploadModule } from './fileupload/fileupload.module';
import { FileSizeModule } from 'ngx-filesize';
import { AcceptDeclineDialogComponent } from './dialog/accept-decline-dialog/accept-decline-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MessageDialogComponent } from './dialog/message-dialog/message-dialog.component';
import { ReactiveFormsModule } from "@angular/forms";
import { InprocessComponent } from './inprocess/inprocess.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SuccessMessageToastComponent } from './toast/success-message-toast/success-message-toast.component';
import { ProvidedComponent } from './provided/provided.component';
import { MatSortModule } from "@angular/material";
import { ContactComponent } from './contact/contact.component';
import { MatListModule } from '@angular/material/list';
import {AddLeadingZerosModule} from "./pipes/add-leading-zeros.module";
import { SuccessSaveToastComponent } from './toast/success-save-toast/success-save-toast.component';
import { SaveHotspotTemplateNoRowToastComponent } from './toast/save-hotspot-template-no-row-toast/save-hotspot-template-no-row-toast.component';
import {from} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "../environments/environment";
import {SharedModule} from "./shared/shared.module";
import {AuthInterceptor} from "./auth/auth-http-interceptor";
import {ImgAuthPipe} from './auth/img-auth.pipe';
import {AuthGuard} from './service/auth/auth.guard';
import {LoginComponent} from './login/login.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

const initApp = () => {
  return () => {
    return from(
      fetch('assets/config/environment.json').then(function (response) {
        return response.json();
      })
    ).pipe(
      map((config) => {
        console.log(config);
        environment.production = config.production;
        environment.packagesManagerBackendUrl = config.packagesManagerBackendUrl;
        environment.domainUrl = config.domainUrl;
        environment.basicAuthLogout = config.basicAuthLogout;
      })).toPromise();
  }
};

@NgModule({
  declarations: [
    AppComponent,
    AcceptDeclineDialogComponent,
    MessageDialogComponent,
    InprocessComponent,
    SuccessMessageToastComponent,
    ProvidedComponent,
    ContactComponent,
    SuccessSaveToastComponent,
    SaveHotspotTemplateNoRowToastComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    WorkflowModule,
    MatMenuModule,
    MatIconModule,
    HttpClientModule,
    FileuploadModule,
    FileSizeModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatListModule,
    SharedModule,
    AddLeadingZerosModule.forRoot(),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    })
  ],
  exports: [],
  providers: [
    AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      multi: true
    },
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
